import * as screens from '@core/layouts/components/menu/screens';
import paths from 'views/screens/BulkInserts/paths';
import permissions from 'views/screens/BulkInserts/permissions';

export default [
  {
    id: 'bulkInserts',
    title: 'bulkInserts.title',
    icon: 'Upload',
    permissions: [permissions.viewBulkInserts],
    iconName: 'Upload',
    navLink: paths.listBulkInserts,
    screenId: screens.BULK_INSERTS
  }
];
